import { render, staticRenderFns } from "./TripMovementItem.vue?vue&type=template&id=3f273026&scoped=true&lang=pug"
import script from "./TripMovementItem.vue?vue&type=script&lang=js"
export * from "./TripMovementItem.vue?vue&type=script&lang=js"
import style0 from "./TripMovementItem.vue?vue&type=style&index=0&id=3f273026&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f273026",
  null
  
)

export default component.exports